import { Sidebar, useSidebarState } from 'react-admin';
import { Box } from '@mui/material';
import Logo from '../assets/logo.png';
import Favicon from '../assets/favicon.png';

const CustomSidebar = (props) => {
    const [open] = useSidebarState(); // Get the sidebar's open state

    return (
        <Box
            sx={{
                backgroundColor: '#1a1c1e',
                height: '100vh',
                position: 'fixed',
                width: open ? 240 : 60, // 240px when open, 60px when closed
                color: 'white',
                transition: 'width 0.3s', // Smooth transition for width change
            }}
        >
            <Box
                sx={{
                    padding: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 1,
                    borderBottom: '1px solid rgba(255,255,255,0.1)',
                    marginBottom: 2,
                }}
            >
                <img
                    src={open ? Logo : Favicon}
                    alt={open ? 'Logo' : 'Favicon'}
                    height={open ? 40 : 32} // Slightly smaller favicon when collapsed
                />
            </Box>
            <Sidebar
                sx={{
                    marginTop: '0 !important',
                    '& .MuiMenuItem-root': {
                        color: 'rgba(255,255,255,0.7)',
                        padding: '8px 20px',
                        '& .RaMenuItemLink-icon': {
                            color: 'rgba(255,255,255,0.7)',
                        },
                        '&:hover': {
                            color: 'white',
                            backgroundColor: 'rgba(255,255,255,0.1)',
                        },
                        '&.RaMenuItemLink-active': {
                            color: 'white',
                            backgroundColor: 'rgba(255,255,255,0.1)',
                        },
                    },
                }}
                {...props}
            />
        </Box>
    );
};

export default CustomSidebar;
